/*
 * Public API Surface of ngx-editor
 */

export * from './lib/ngx-editor.component';
export * from './lib/ngx-editor.module';

export * from './lib/schema';

export * from './lib/prosemirror/plugins';
export * from './lib/prosemirror/commands';
export * from './lib/prosemirror/helpers';

export * from './lib/types';
